import { render, staticRenderFns } from "./HowToChoose.vue?vue&type=template&id=9c122318&scoped=true"
import script from "./HowToChoose.vue?vue&type=script&lang=js"
export * from "./HowToChoose.vue?vue&type=script&lang=js"
import style0 from "./HowToChoose.vue?vue&type=style&index=0&id=9c122318&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c122318",
  null
  
)

export default component.exports